/* ===========================================================================
   sz-jdgm-pdp.js — Judge.me PDP review-card enhancements
   AI Agent làm theo chỉ thị của anh Hoá — 2026-09-15 19:10 VN — WEB-20260915-suzitee-jdgm-pdp-grid
   Đã làm: thêm 2 thứ nhỏ cho card review trên PDP —
     (1) review có NHIỀU ảnh: biến dải ảnh thành carousel trượt ngang + chấm chỉ báo
         (trước: các thumbnail xếp cạnh nhau, tràn card).
     (2) review có body DÀI: clamp 5 dòng + nút "Read more" (trước: không clamp).
   Không đụng DOM ngoài .jdgm-review-widget; không sửa nội dung review;
   giữ nguyên lightbox ảnh, sort, pagination và form gửi review của Judge.me.
   =========================================================================== */
(function () {
  'use strict';

  var ROOT_SEL = '.jdgm-review-widget';
  var CLAMP_LINES = 4; // R5: matches the 4-line clamp in the CSS (equal card heights)
  var MIN_CHARS = 180; // chỉ clamp khi body thực sự dài

  /* ------------------------------------------------------------------ R5
     BLUR FIX. Judge.me serves review photos from review-images.judgeme.com
     with a `width=` query param and hard-codes width=160 (the size its own
     small-thumb layout used). Our card photo is 180/200/295/335 CSS px and the
     owner's screen is dpr 2, so a 160px file was being blown up 4x → mush.
     Almagems has exactly the same problem and solves it the same way: their
     imgix URLs carry `w=<renderedWidth>&dpr=2` (natW 635 for a 317.25px box).
     The CDN happily serves any width up to the original upload
     (verified: 160/400/700/1024 all returned, capped at the 1179px original).
     So: recompute the width param from the real rendered box × dpr.
     No CSS filter, no image-rendering — this adds actual pixels.        */
  var WIDTH_STEPS = [160, 240, 320, 400, 480, 560, 640, 720, 800, 900, 1024, 1200, 1400, 1600];

  function stepUp(n) {
    for (var i = 0; i < WIDTH_STEPS.length; i++) if (WIDTH_STEPS[i] >= n) return WIDTH_STEPS[i];
    return WIDTH_STEPS[WIDTH_STEPS.length - 1];
  }

  function retargetUrl(url, want) {
    if (!url) return null;
    // judgeme review-images:  ...?quality=80&width=160
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + want);
    // imgix style: ...?auto=format&w=317.25&dpr=2
    if (/[?&]w=[\d.]+/.test(url)) return url.replace(/([?&]w=)[\d.]+/, '$1' + want);
    if (/^https?:/.test(url) && url.indexOf('judgeme') > -1) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + want;
    }
    return null;
  }

  /* R9. Judge.me paints each photo link with `jdgm--loading` (spinner + the img
     at visibility:hidden) and strips that class from its OWN onload handler,
     which is only wired for nodes present at widget init. Cards appended by
     boostPerPage() therefore kept the spinner forever and never showed the
     photo. Strip it ourselves once the image has actually decoded. */
  function unspin(im) {
    try {
      var link = im.closest ? im.closest('.jdgm-rev__pic-link') : null;
      if (!link || !link.classList.contains('jdgm--loading')) return;
      if (im.complete && im.naturalWidth) link.classList.remove('jdgm--loading');
      else if (!im.getAttribute('data-sz-unspin')) {
        im.setAttribute('data-sz-unspin', '1');
        im.addEventListener('load', function () { link.classList.remove('jdgm--loading'); });
        im.addEventListener('error', function () { link.classList.remove('jdgm--loading'); });
      }
    } catch (e) { /* noop */ }
  }

  function upscalePics(pics) {
    try {
      var dpr = Math.min(window.devicePixelRatio || 1, 2); // 2 is enough, 3 doubles bytes for nothing
      var imgs = pics.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        (function (im) {
          unspin(im);
          var boxW = Math.round(im.getBoundingClientRect().width || pics.clientWidth || 0);
          if (!boxW) return;
          if (!im.getAttribute('data-sz-onload')) {
            im.setAttribute('data-sz-onload', '1');
            // intrinsic ratio is unknown until the first rendition has loaded;
            // re-evaluate then so landscape photos get the extra width they need
            im.addEventListener('load', function () { upscalePics(pics); });
          }
          // The rendition keeps the original aspect ratio. We crop square with
          // object-fit:cover, so a LANDSCAPE photo needs extra width for its
          // (shorter) height to cover the square box.
          var ar = (im.naturalWidth && im.naturalHeight) ? (im.naturalWidth / im.naturalHeight) : 1;
          var need = boxW * dpr * (ar > 1 ? ar : 1);
          var want = stepUp(Math.ceil(need));
          var cur = +((im.getAttribute('src') || '').match(/[?&](?:width|w)=([\d.]+)/) || [0, 0])[1];
          if (cur >= want) { im.setAttribute('data-sz-hi', String(cur)); return; }
          if (im.getAttribute('data-sz-hi') === String(want)) return;
          var next = retargetUrl(im.getAttribute('src') || im.getAttribute('data-src'), want);
          if (!next) return;
          im.setAttribute('data-sz-hi', String(want));
          im.setAttribute('src', next);
          if (im.hasAttribute('data-src')) im.setAttribute('data-src', next);
          im.removeAttribute('srcset'); // nothing else may override our pick
        })(imgs[i]);
      }
    } catch (e) { /* never break the widget */ }
  }

  function setupPics(rev) {
    try {
      var pics = rev.querySelector('.jdgm-rev__pics');
      if (!pics) return;
      // R9: cards we appended ourselves keep Judge.me's `jdgm--loading` class on
      // .jdgm-rev__pic-link (its own load handler never ran for them), and that
      // class hides the image (visibility:hidden) behind a spinner. Clear it once
      // the photo has actually decoded. Cards rendered by Judge.me are unaffected
      // (the class is already gone).
      var ldg = pics.querySelectorAll('.jdgm-rev__pic-link.jdgm--loading');
      for (var L = 0; L < ldg.length; L++) {
        (function (a) {
          var im = a.querySelector('img');
          if (!im) { a.classList.remove('jdgm--loading'); return; }
          if (im.complete && im.naturalWidth) { a.classList.remove('jdgm--loading'); return; }
          im.addEventListener('load', function () { a.classList.remove('jdgm--loading'); });
          im.addEventListener('error', function () { a.classList.remove('jdgm--loading'); });
        })(ldg[L]);
      }
      // run on every pass: the box width changes on resize / breakpoint
      upscalePics(pics);
      if (pics.getAttribute('data-sz-pics') === '1') return;
      var links = pics.querySelectorAll('.jdgm-rev__pic-link, a');
      if (!links.length) { pics.setAttribute('data-sz-pics', '1'); return; }

      // hydrate lazy images so they paint inside the new square cell
      var imgs = pics.querySelectorAll('img[data-src]');
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        if (!im.getAttribute('src') || im.getAttribute('src').indexOf('data:') === 0) {
          im.setAttribute('src', im.getAttribute('data-src'));
        }
      }

      if (links.length > 1) {
        pics.classList.add('sz-pics--slider');

        var dots = document.createElement('div');
        dots.className = 'sz-pics-dots';
        dots.setAttribute('role', 'tablist');
        dots.setAttribute('aria-label', 'Review photos');

        for (var d = 0; d < links.length; d++) {
          (function (idx) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'sz-pics-dot' + (idx === 0 ? ' is-active' : '');
            b.setAttribute('aria-label', 'Photo ' + (idx + 1) + ' of ' + links.length);
            b.addEventListener('click', function (e) {
              e.preventDefault();
              pics.scrollTo({ left: idx * pics.clientWidth, behavior: 'smooth' });
            });
            dots.appendChild(b);
          })(d);
        }
        // dots live right after the photo strip, inside the card
        if (pics.parentNode) pics.parentNode.insertBefore(dots, pics.nextSibling);

        var ticking = false;
        pics.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var w = pics.clientWidth || 1;
            var active = Math.round(pics.scrollLeft / w);
            var all = dots.children;
            for (var k = 0; k < all.length; k++) {
              var on = k === active;
              if (all[k].classList.contains('is-active') !== on) {
                all[k].classList.toggle('is-active', on); // chỉ đổi khi state đổi
              }
            }
          });
        }, { passive: true });
      }

      pics.setAttribute('data-sz-pics', '1');
    } catch (e) { /* never break the widget */ }
  }

  /* ROUND 3 — 2026-09-17 VN — WEB-20260917-suzitee-review-readmore
     Đã làm: XOÁ hẳn hàm setupClamp() cũ (wrapper .sz-rev-clamp + nút
     .sz-read-more + -webkit-line-clamp). Lý do: nó đo scrollHeight lúc widget
     Judge.me còn bị .jdgm-temp-hiding-style ẩn nên luôn ra 0, rồi gắn cờ
     data-sz-clamp='1' nên không bao giờ đo lại -> PDP chưa từng có "Read more".
     Thay bằng szMakeTruncator() ở cuối file: cắt CHỮ 3 dòng + "…" + <a> inline,
     đúng cơ chế đo được trên tham chiếu almagems ngày 2026-09-17. */

  /* On the PDP widget Judge.me hides the product link (visibility:hidden) because
     every review belongs to this product — but the row still occupies ~33px and
     leaves a blank gap in the card. Collapse it. On widgets where the link IS
     visible (all-reviews page) nothing changes. */
  /* ROUND 11 — cards appended by boostPerPage() come from Judge.me's AJAX markup,
     which omits the green product line the server-rendered cards carry. The AJAX
     payload DOES carry the real identity per review (data-product-title +
     data-product-url on the .jdgm-rev node), so we rebuild Judge.me's own
     structure from that review's OWN data. Nothing is derived from the current
     PDP — this widget is shop-wide, so a page-derived link would be wrong. If
     either field is missing we build nothing rather than show a false product. */
  function ensureProdLink(rev) {
    try {
      // ONLY cards we appended from the AJAX payload. Server-rendered cards get
      // their own row from Judge.me (sometimes late, after our first scan) — touching
      // them produced a DUPLICATE green line, seen in shots/v11-sim-1440.jpg.
      if (rev.getAttribute('data-sz-ajax') !== '1') return;
      if (rev.querySelector('.jdgm-rev__prod-link')) return;
      var title = (rev.getAttribute('data-product-title') || '').trim();
      var url = (rev.getAttribute('data-product-url') || '').trim();
      if (!title || url.indexOf('/products/') !== 0) return; // never fabricate
      var head = rev.querySelector('.jdgm-rev__header');
      if (!head) return;
      var row = document.createElement('div');
      row.className = 'jdgm-row-product';
      var wrap = document.createElement('span');
      wrap.className = 'jdgm-rev__prod-info-wrapper';
      var pre = document.createElement('span');
      pre.className = 'jdgm-rev__prod-link-prefix';
      var a = document.createElement('a');
      a.className = 'jdgm-rev__prod-link';
      a.setAttribute('target', '_blank');
      a.setAttribute('href', url);
      a.textContent = title;            // textContent: no markup injection
      wrap.appendChild(pre);
      wrap.appendChild(document.createTextNode(' '));
      wrap.appendChild(a);
      row.appendChild(wrap);
      head.insertBefore(row, head.firstChild);
    } catch (e) { /* never break the widget */ }
  }

  function setupProdRow(rev) {
    try {
      ensureProdLink(rev);
      var row = rev.querySelector('.jdgm-row-product');
      if (!row || row.getAttribute('data-sz-prod') === '1') return;
      row.setAttribute('data-sz-prod', '1');
      var link = row.querySelector('.jdgm-rev__prod-link');
      var hidden = !link ||
        getComputedStyle(link).visibility === 'hidden' ||
        !(link.textContent || '').trim();
      if (hidden) row.classList.add('sz-prod-hidden');
    } catch (e) { /* noop */ }
  }

  /* ROUND 6 — display-only reviewer-name cleanup.
     Judge.me serves some imported reviews with the literal word "Customer"
     glued to the name ("CustomerLloyd Hootman", "LizCustomer"). Verified
     server-side on the LIVE theme too, so it is review DATA, not our CSS.
     We only strip the glued token at render time; the review itself is
     never modified. A reviewer genuinely named "Customer" is left alone. */
  function setupAuthor(rev) {
    try {
      var a = rev.querySelector('.jdgm-rev__author');
      if (!a || a.getAttribute('data-sz-author')) return;
      var o = (a.textContent || '').trim();
      var t = o.replace(/^Customer(?=[A-Z][a-z])/, '').replace(/([a-z])Customer$/, '$1').trim();
      if (t && t !== o) a.textContent = t;
      a.setAttribute('data-sz-author', '1');
    } catch (e) { /* noop */ }
  }

  function scan(root) {
    var revs = root.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev');
    for (var i = 0; i < revs.length; i++) {
      setupAuthor(revs[i]);
      setupProdRow(revs[i]);
      setupPics(revs[i]);
      // ROUND 3 — 2026-09-17 VN — WEB-20260917-suzitee-review-readmore
      // Đã làm: bỏ lời gọi setupClamp() (bản clamp CSS cũ không bao giờ kích hoạt
      // được vì đo scrollHeight lúc widget còn ẩn). Việc thu gọn nội dung nay do
      // szMakeTruncator() ở cuối file lo, đúng cơ chế cắt-chữ của tham chiếu.
    }
  }

  /* ------------------------------------------------------------------ R9
     8 REVIEWS PER PAGE, theme-side.
     The storefront runs the CLASSIC v3 widget. Its first page is SERVER-rendered
     into the PDP HTML from Judge.me's cached metafield with 5 cards, and every
     later page is fetched by the widget itself from `.jdgm-paginate[data-url]`
     using `.jdgm-paginate[data-per-page]` — NOT from window.jdgmSettings
     (verified: patching jdgmSettings.pagination changed nothing; patching
     data-per-page to 8 made a page-2 click return exactly 8 cards).

     So we do the least invasive thing possible:
       1. fetch page 1 at per_page=8 in the background,
       2. APPEND only cards 6-8 to the existing list — the 5 server-rendered
          cards are never touched, never replaced, never re-parsed, so there is
          no flash and no double render,
       3. only THEN flip data-per-page to 8 so pages 2+ stay in step.
     Verified that page-1-at-8 starts with exactly the same 5 review ids as the
     server-rendered page, so the 5+3 join lines up with page 2 = reviews 9-16.

     DEGRADATION: every failure path (no pager, fetch error, timeout, bad JSON,
     fewer cards than expected, all duplicates) returns with data-per-page still
     at its original value and the DOM untouched — the user sees the normal 5
     and stock pagination. data-per-page is flipped ONLY after cards are in. */
  var PER_PAGE = 8;
  var SHOP_FALLBACK = 'af7e11-2.myshopify.com';

  function boostPerPage(root) {
    try {
      var pager = root.querySelector('.jdgm-paginate');
      if (!pager || pager.getAttribute('data-sz-pp')) return;
      var cur = parseInt(pager.getAttribute('data-per-page'), 10) || 0;
      if (!cur || cur >= PER_PAGE) return;
      var curPage = pager.querySelector('.jdgm-paginate__page.jdgm-curt');
      if (curPage && curPage.getAttribute('data-page') !== '1') return; // only the first render
      var list = root.querySelector('.jdgm-rev-widg__reviews');
      if (!list) return;
      var existing = list.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev');
      existing = [];
      for (var c = 0; c < list.children.length; c++) {
        if (list.children[c].classList && list.children[c].classList.contains('jdgm-rev')) existing.push(list.children[c]);
      }
      if (existing.length !== cur) return; // unexpected state → leave stock

      pager.setAttribute('data-sz-pp', 'pending');
      var pid = root.getAttribute('data-product-id') || root.getAttribute('data-id') || '';
      var shop = (window.jdgmSettings && (window.jdgmSettings.shop_domain || window.jdgmSettings.shop)) || SHOP_FALLBACK;
      var base = pager.getAttribute('data-url') || 'https://api.judge.me/reviews/reviews_for_widget';
      var url = base + '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&page=1&per_page=' + PER_PAGE + (pid ? '&product_id=' + encodeURIComponent(pid) : '');

      var settled = false;
      var giveUp = setTimeout(function () {
        if (!settled) { settled = true; pager.setAttribute('data-sz-pp', 'timeout'); }
      }, 8000);

      fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (settled) return;
        settled = true; clearTimeout(giveUp);
        if (!j || !j.html) { pager.setAttribute('data-sz-pp', 'nohtml'); return; }
        var tmp = document.createElement('div');
        tmp.innerHTML = j.html;
        var cards = tmp.querySelectorAll('.jdgm-rev');
        if (cards.length <= existing.length) { pager.setAttribute('data-sz-pp', 'short'); return; }

        var have = {};
        for (var i = 0; i < existing.length; i++) have[existing[i].getAttribute('data-review-id')] = 1;
        var added = 0;
        for (var k = 0; k < cards.length; k++) {
          var id = cards[k].getAttribute('data-review-id');
          if (id && have[id]) continue;
          cards[k].setAttribute('data-sz-ajax', '1'); // provenance for ensureProdLink()
          list.appendChild(cards[k]);
          added++;
          if (existing.length + added >= PER_PAGE) break;
        }
        if (!added) { pager.setAttribute('data-sz-pp', 'dupe'); return; }

        pager.setAttribute('data-per-page', String(PER_PAGE));
        // the last-page link was computed at 5/page — recompute it for 8/page
        var total = parseInt(j.total_count, 10) || 0;
        if (total) {
          var lastN = Math.ceil(total / PER_PAGE);
          var last = pager.querySelector('.jdgm-paginate__last-page');
          if (last) { last.setAttribute('data-page', String(lastN)); last.setAttribute('aria-label', 'Page ' + lastN); }
          var links = pager.querySelectorAll('.jdgm-paginate__page');
          for (var m = 0; m < links.length; m++) {
            var pn = parseInt(links[m].getAttribute('data-page'), 10);
            if (pn > lastN) links[m].parentNode.removeChild(links[m]);
          }
        }
        pager.setAttribute('data-sz-pp', '1');
        scan(root); // enhance the freshly appended cards immediately
      })['catch'](function () {
        if (settled) return;
        settled = true; clearTimeout(giveUp);
        pager.setAttribute('data-sz-pp', 'error'); // DOM untouched, still 5
      });
    } catch (e) { /* never break the widget */ }
  }

  function boot() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return false;
    scan(root);
    boostPerPage(root);

    // Judge.me re-renders the list on sort / pagination / load-more.
    // Observe ONLY the list container, childList only (perf-guardrails).
    // ROUND 4 fix: on sort / pagination Judge.me REPLACES the whole
    // .jdgm-rev-widg__reviews node, so an observer bound to that node is left
    // watching a detached element and the new cards never get enhanced
    // (verified by interaction test: page-2 cards had no clamp wrapper).
    // Observe the widget root instead; scan() is idempotent (data-sz-* guards)
    // and the callback is rAF-debounced, so this stays cheap.
    if (!root.getAttribute('data-sz-obs')) {
      root.setAttribute('data-sz-obs', '1');
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; scan(root); });
      });
      mo.observe(root, { childList: true, subtree: true });
    }
    return true;
  }

  function start() {
    if (boot()) return;
    // widget is injected async — retry on a short bounded schedule, then stop
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (boot() || tries > 40) clearInterval(iv); // max ~20s
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ==========================================================================
   SZ REVIEW TRUNCATOR — parity 1:1 với cơ chế THẬT của tham chiếu Judge.me
   (almagems.com), đo lại 2026-09-17: KHÔNG dùng -webkit-line-clamp.
   Tham chiếu CẮT CHÍNH VĂN BẢN rồi chèn thẻ <a> "Read more" ngay cuối dòng
   chảy (computed: clamp none, maxHeight none, overflow visible,
   scrollHeight === clientHeight). Body 13px / line-height 18.46px, phần thu
   gọn cao 75px = 3 dòng chữ + "…", chữ "Read more" rơi xuống dòng 4.
   Ngân sách ký tự KHÔNG cố định: nó co giãn theo bề rộng card (~59-79 ký tự
   @390, ~145 @1440) nên ở đây ta ĐO hình học thật chứ không hardcode số ký tự.
   Bấm "Read more" => full text thay tại chỗ, card cao lên, nút biến mất.
   MỘT CHIỀU, không có "Read less" (đúng tham chiếu).
   ========================================================================== */
function szMakeTruncator(opts) {
  'use strict';
  var LINES = 3;                    // 3 dòng chữ; anchor tự rớt xuống dòng 4
  var BODY_SEL = '.jdgm-rev__body';
  var A_CLASS = 'jdgm-rev__body-read-more';
  var LABEL = 'Read more';
  var measurer = null;
  var busy = false;

  function getMeasurer() {
    if (measurer && measurer.parentNode) return measurer;
    measurer = document.createElement('div');
    measurer.setAttribute('aria-hidden', 'true');
    measurer.style.cssText =
      'position:absolute!important;left:-99999px!important;top:0!important;' +
      'visibility:hidden!important;pointer-events:none!important;' +
      'white-space:normal!important;overflow:visible!important;max-height:none!important;' +
      'min-height:0!important;height:auto!important;padding:0!important;margin:0!important;border:0!important;';
    document.body.appendChild(measurer);
    return measurer;
  }

  /* Sao chép đúng các thuộc tính chữ ảnh hưởng tới việc xuống dòng, và dùng
     bề rộng CONTENT-BOX thật của body để đo -> số ký tự cắt tự co theo card. */
  function syncMeasurer(body) {
    var m = getMeasurer();
    var c = window.getComputedStyle(body);
    var w = body.clientWidth -
            (parseFloat(c.paddingLeft) || 0) - (parseFloat(c.paddingRight) || 0);
    if (!(w > 20)) return null;
    m.style.width = w + 'px';
    m.style.font = c.font && c.font !== '' ? c.font : '';
    m.style.fontSize = c.fontSize;
    m.style.fontFamily = c.fontFamily;
    m.style.fontWeight = c.fontWeight;
    m.style.fontStyle = c.fontStyle;
    m.style.lineHeight = c.lineHeight;
    m.style.letterSpacing = c.letterSpacing;
    m.style.wordSpacing = c.wordSpacing;
    m.style.wordBreak = c.wordBreak;
    m.style.overflowWrap = c.overflowWrap;
    m.style.textTransform = c.textTransform;
    return { m: m, lh: parseFloat(c.lineHeight) || 18.46 };
  }

  function fits(m, text, maxH) {
    m.textContent = text;
    return m.scrollHeight <= maxH;
  }

  function makeAnchor() {
    var a = document.createElement('a');
    a.className = A_CLASS + (opts.extraAnchorClass ? ' ' + opts.extraAnchorClass : '');
    a.setAttribute('role', 'button');
    a.setAttribute('tabindex', '0');
    a.setAttribute('data-sz-rm', '1');
    a.textContent = LABEL;
    return a;
  }

  function expand(body) {
    var html = body.getAttribute('data-sz-html');
    if (html == null) return;
    body.setAttribute('data-sz-open', '1');
    body.classList.remove('is-truncated');
    body.innerHTML = html;                    // full text thay tại chỗ, nút biến mất
  }

  /* Idempotent: MỌI lần chạy đều dựng lại từ data-sz-html gốc nên không bao giờ
     đẻ ra 2 nút, kể cả sau sort / filter / phân trang / card nạp bằng AJAX. */
  function apply(body) {
    if (!body || body.getAttribute('data-sz-open') === '1') return;

    var full = body.getAttribute('data-sz-full');
    if (full === null) {
      var t = (body.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t) return;                          // chưa có chữ -> để lượt sau, KHÔNG đánh dấu xong
      full = t;
      body.setAttribute('data-sz-full', full);
      body.setAttribute('data-sz-html', body.innerHTML);
    }

    var ctx = syncMeasurer(body);
    if (!ctx) return;                          // chưa layout (widget còn display:none) -> lượt sau
    var maxH = ctx.lh * LINES + 1;

    if (fits(ctx.m, full, maxH)) {             // review ngắn: KHÔNG có nút
      if (body.classList.contains('is-truncated') || body.getAttribute('data-sz-cut')) {
        body.removeAttribute('data-sz-cut');
        body.classList.remove('is-truncated');
        body.innerHTML = body.getAttribute('data-sz-html');
      }
      return;
    }

    // nhị phân theo RANH GIỚI TỪ: lấy đoạn dài nhất vẫn nằm trong 3 dòng
    var words = full.split(' ');
    var lo = 1, hi = words.length - 1, best = 1;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (fits(ctx.m, words.slice(0, mid).join(' ') + '…', maxH)) { best = mid; lo = mid + 1; }
      else hi = mid - 1;
    }
    var cut = words.slice(0, best).join(' ').replace(/[\s.,;:!?-]+$/, '') + '… ';
    if (body.getAttribute('data-sz-cut') === cut && body.classList.contains('is-truncated')) return;

    body.setAttribute('data-sz-cut', cut);
    body.innerHTML = '';
    body.appendChild(document.createTextNode(cut));
    body.appendChild(makeAnchor());
    body.classList.add('is-truncated');
  }

  function runOn(root) {
    if (!root || busy) return;
    busy = true;
    try {
      var bodies = root.querySelectorAll(BODY_SEL);
      for (var i = 0; i < bodies.length; i++) {
        try { apply(bodies[i]); } catch (e) { /* không bao giờ chặn Judge.me */ }
      }
    } catch (e) { /* noop */ } finally { busy = false; }
  }

  function bindOnce(root) {
    if (root.getAttribute('data-sz-rm-bound') === '1') return;
    root.setAttribute('data-sz-rm-bound', '1');
    // uỷ quyền sự kiện ở container -> sống sót mọi lần Judge.me dựng lại card
    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-sz-rm="1"]') : null;
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();
      var body = a.closest('.jdgm-rev__body');
      if (body) expand(body);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var a = e.target && e.target.closest ? e.target.closest('[data-sz-rm="1"]') : null;
      if (!a) return;
      e.preventDefault();
      var body = a.closest('.jdgm-rev__body');
      if (body) expand(body);
    });
  }

  return {
    /* observer HẸP: chỉ container review, childList, rAF gộp nhịp, và NGẮT
       observer trong lúc ta tự ghi DOM -> không thể tự kích vòng lặp (bài học r10). */
    attach: function (root) {
      if (!root) return false;
      bindOnce(root);
      runOn(root);
      if (root.getAttribute('data-sz-rm-obs') !== '1') {
        root.setAttribute('data-sz-rm-obs', '1');
        var pending = false;
        var sweepTs = [];
        /* Judge.me nhả card thành NHIỀU nhịp (sort / lọc / phân trang / AJAX) và
           có lúc còn đang ẩn tạm -> đo ra bề rộng 0. Một lần chạy theo rAF là
           KHÔNG đủ: QC 2026-09-17 bắt được card 188 ký tự vẫn nguyên văn sau khi
           đổi sort. Nên sau mỗi đợt mutation ta quét lại vài nhịp thưa có giới hạn. */
        function sweepLater() {
          for (var i = 0; i < sweepTs.length; i++) clearTimeout(sweepTs[i]);
          sweepTs = [];
          var delays = [160, 600, 1500, 3000];
          for (var d = 0; d < delays.length; d++) {
            sweepTs.push(setTimeout(function () {
              mo.disconnect();
              runOn(root);
              mo.observe(root, { childList: true, subtree: true });
            }, delays[d]));
          }
        }
        var mo = new MutationObserver(function () {
          if (pending) return;
          pending = true;
          window.requestAnimationFrame(function () {
            pending = false;
            mo.disconnect();
            runOn(root);
            mo.observe(root, { childList: true, subtree: true });
            sweepLater();
          });
        });
        mo.observe(root, { childList: true, subtree: true });
        sweepLater();
        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(function () {
            // đổi bề rộng => ngân sách ký tự đổi => dựng lại từ bản gốc
            var bodies = root.querySelectorAll('.jdgm-rev__body[data-sz-cut]');
            for (var i = 0; i < bodies.length; i++) bodies[i].removeAttribute('data-sz-cut');
            runOn(root);
          }, 220);
        }, { passive: true });
      }
      return true;
    },
    run: runOn
  };
}

/* ==========================================================================
   ROUND 3 — gắn truncator vào widget review trên PDP
   AI Agent làm theo chỉ thị của anh Hoá — 2026-09-17 VN — WEB-20260917-suzitee-review-readmore
   Đã làm:
   (1) Dọn dấu vết bản clamp CSS cũ trong sz-jdgm-pdp.js (wrapper .sz-rev-clamp
       + nút .sz-read-more + class .sz-clamped + cờ data-sz-clamp). Bản cũ không
       bao giờ kích hoạt được vì nó đo scrollHeight lúc widget còn bị ẩn tạm
       (scrollHeight = 0) rồi tự gắn cờ "đã xử lý" nên không đo lại — đo thật
       2026-09-17: 8/8 card có data-sz-clamp=1 mà 0 card được clamp.
   (2) Thay bằng cơ chế ĐÚNG tham chiếu: cắt CHỮ về 3 dòng + "…" + thẻ <a>
       "Read more" inline; bấm là mở hẳn, không có "Read less".
   Phạm vi: chỉ chạy khi có .jdgm-review-widget; file này chỉ được nạp trong
   {% if template contains 'product' %} ở layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';
  try {
    var ROOT_SEL = '.jdgm-review-widget';
    var tr = szMakeTruncator({});

    // (1) gỡ markup của bản clamp cũ, trả body về đúng chữ gốc trước khi cắt lại
    function cleanLegacy(root) {
      try {
        var wraps = root.querySelectorAll('.sz-rev-clamp');
        for (var i = 0; i < wraps.length; i++) {
          var w = wraps[i], p = w.parentNode;
          if (!p) continue;
          while (w.firstChild) p.insertBefore(w.firstChild, w);
          p.removeChild(w);
        }
        var btns = root.querySelectorAll('.sz-read-more');
        for (var j = 0; j < btns.length; j++) {
          if (btns[j].parentNode) btns[j].parentNode.removeChild(btns[j]);
        }
        var bodies = root.querySelectorAll('.jdgm-rev__body[data-sz-clamp],.jdgm-rev__body.sz-clamped');
        for (var k = 0; k < bodies.length; k++) {
          bodies[k].classList.remove('sz-clamped');
          bodies[k].removeAttribute('data-sz-clamp');
        }
      } catch (e) { /* noop */ }
    }

    function boot() {
      var root = document.querySelector(ROOT_SEL);
      if (!root) return false;
      cleanLegacy(root);
      return tr.attach(root);
    }

    function start() {
      var ok = boot();
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        try {
          var root = document.querySelector(ROOT_SEL);
          if (root) { cleanLegacy(root); ok = tr.attach(root) || ok; tr.run(root); }
        } catch (e) { /* noop */ }
        if (tries >= 14) clearInterval(iv);   // tối đa ~11s
      }, 800);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else { start(); }
  } catch (e) { /* không bao giờ chặn Judge.me */ }
})();
